module.exports = __webpack_public_path__ + "static/Gotham-UltraItalic-5259aa15efd5de3dbaa1827fa197ff00.woff";